<template>
    <section>
        <div class="first_img">
            <Carousel :autoplay="autoplayVal" v-model="value2" loop radius-dot :autoplay-speed="3000" easing="linear">
                <CarouselItem>
                    <div class="demo-carousel">
                        <img src="../../assets/productIntro/01.png" alt="海马行">
                    </div>
                </CarouselItem>
                <CarouselItem>
                    <div class="demo-carousel">
                        <img src="../../assets/productIntro/02.png" alt="海马行">
                    </div>
                </CarouselItem>
                <CarouselItem>
                    <div class="demo-carousel">
                        <img src="../../assets/productIntro/03.png" alt="海马行">
                    </div>
                </CarouselItem>
                <CarouselItem>
                    <div class="demo-carousel">
                        <img src="../../assets/productIntro/04.png" alt="海马行">
                    </div>
                </CarouselItem>
            </Carousel>
        </div>
        <!-- 产品图谱 -->
        <div class="product_img">
            <div class="product_img_box">
                <div class="part_title">
                    <p>产品图谱</p>
                    <span></span>
                    <p class="intro">全平台兼容，操作更方便</p>
                </div>
                <div class="rotation_chant_box">
                    <rotateImg></rotateImg>
                </div>
            </div>
        </div>
        <!-- 营销手段 -->
        <div class="marketingMeans">
            <div class="marketingMeans_box">
                <div class="part_title">
                    <p>营销手段</p>
                    <span></span>
                    <p class="intro">精准寻找客源，多方位渠道展示店铺，吸引海量会员，提升店铺销量</p>
                </div>
                <div class="marketingMeans_list">
                    <div class="marketingMeans_item">
                        <div class="img_box">
                            <img src="../../assets/productIntro/vip.jpg" alt="">
                        </div>
                        <p class="title">会员管理</p>
                        <div class="content">
                            会员标签化管理、精细化运营、差异化营销，会员等级、积分、代金券，打破传统价格战模式。
                        </div>
                    </div>
                    <div class="marketingMeans_item">
                        <div class="img_box">
                            <img src="../../assets/productIntro/yxmb.jpg" alt="">
                        </div>
                        <p class="title">50+套营销模板</p>
                        <div class="content">
                            不断更新的营销模板，满足油站不同场景的活动需求。
                        </div>
                    </div>
                    <div class="marketingMeans_item">
                        <div class="img_box">
                            <img src="../../assets/productIntro/yytj.jpg" alt="">
                        </div>
                        <p class="title">异业推荐</p>
                        <div class="content">
                            联合社区周边商户建设异业联盟生态体系，为社区用户提供优惠产品及生活服务，提升用户粘度及活跃度。
                        </div>
                    </div>
                    <div class="marketingMeans_item">
                        <div class="img_box">
                            <img src="../../assets/productIntro/xls.jpg" alt="">
                        </div>
                        <p class="title">新零售</p>
                        <div class="content">
                            通过运用大数据、人工智能等先进技术手段，赋能线下便利店，重构消费连接，让经营更智慧。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 多种支付方式 -->
        <div class="multi_pay">
            <div class="multi_pay_box">
                <div class="part_title">
                    <p>多种支付方式</p>
                    <span></span>
                    <p class="intro">微信支付、支付宝支付、扫码支付，让您的油站买入移动支付时代</p>
                </div>
                <div class="pay_img_box">
                    <div class="center_img">
                        <img src="../../assets/productIntro/iphone.png" alt="">
                    </div>
                    <div class="pay_img zhifubao">
                        <img src="../../assets/productIntro/zhifubao.png" alt="">
                        <p>支付宝支付</p>
                    </div>
                    <div class="pay_img saoma">
                        <img src="../../assets/productIntro/saoma.png" alt="">
                        <p>扫码支付</p>
                    </div>
                    <div class="pay_img xianjin">
                        <img src="../../assets/productIntro/xianjin.png" alt="">
                        <p>现金支付</p>
                    </div>
                    <div class="pay_img weixin">
                        <img src="../../assets/productIntro/weixin.png" alt="">
                        <p>微信支付</p>
                    </div>
                    <div class="pay_img yinhangka">
                        <img src="../../assets/productIntro/yinhangka.png" alt="">
                        <p>银行卡支付</p>
                    </div>
                    <div class="pay_img yve">
                        <img src="../../assets/productIntro/yve.png" alt="">
                        <p>余额支付</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 增值服务 -->
        <div class="increment">
            <div class="increment_box">
                <div class="part_title">
                    <p>增值服务</p>
                    <span></span>
                </div>
                <div class="increment_list">
                    <div class="increment_item" :class="{heighter: isActive1}">
                        <div class="over_box" @mouseenter.capture="mouseEnter1" @mouseout="mouseOut1"></div>
                        <div :class="{active1: isActive1}">
                            <div class="item_title" :class="{item_title1: !isActive1, item_titles1: isActive1}">营销代运营服务</div>
                        </div>
                        <ul class="item_content item_content1">
                            <li>微信公众号运营</li>
                            <li>营销策划方案</li>
                            <li>活动指导</li>
                            <li>运营指导</li>
                            <li>物料宣传</li>
                            <li>专业培训</li>
                            <li>宣传推广</li>
                        </ul>
                    </div>
                    <div class="increment_item" :class="{heighter: isActive2}">
                        <div class="over_box" @mouseenter.capture="mouseEnter2" @mouseout="mouseOut2"></div>
                        <div :class="{active1: isActive2}">
                            <div class="item_title" :class="{item_title2: !isActive2, item_titles2: isActive2}">个性化特权服务</div>
                        </div>
                        <ul class="item_content item_content2">
                            <li>
                                <span style="padding-right:14px;">品控管理：</span><span>油品质量全流程监控</span>
                            </li>
                            <li>
                                <span style="padding-right:14px;">客诉代处理：</span><span>车主投诉代解决</span>
                            </li>
                            <li>
                                <span style="padding-right:14px;">油价预测：</span><span>油价走势预测</span>
                            </li>
                            <li>
                                <span style="padding-right:14px;">经理人学院：</span><span>油站管理、服务的培训</span>
                            </li>
                            <li>
                                <span style="padding-right:14px;">托盘大贸：</span><span>解决油站资金垫付需求</span>
                            </li>
                        </ul>
                    </div>
                    <div class="increment_item" :class="{heighter: isActive3}"> 
                        <div class="over_box" @mouseenter.capture="mouseEnter3" @mouseout="mouseOut3"></div>
                        <div :class="{active1: isActive3}">
                            <div class="item_title" :class="{item_title3: !isActive3, item_titles3: isActive3}">产品售后服务</div>
                        </div>
                        <ul class="item_content item_content3">
                            <li>现场培训</li>
                            <li>系统安装调试</li>
                            <li>远程协助</li>
                            <li>持续更新迭代</li>
                            <li>定期巡检</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 成功案例 -->
        <div class="successDemo">
            <div class="successDemo_box">
                <div class="part_title">
                    <p>成功案例</p>
                    <span></span>
                </div>
                <div class="successDemo_content">
                    <div class="content">
                        <p><span style="padding-left:28px;"></span>东北某油站，为了与周边油站竞争，汽油长期优惠0.3元/升。活动虽然有效果，但因为油站无法区分客户，会员与非会员享受的优惠是一样的，所以车主留存度低、复购率低，油站销量遭遇瓶颈。</p>
                        <p><span style="padding-left:28px;"></span>根据油站当前情况，海马行提供了全面的会员营销方案和领先的信息化平台及人工智能技术，为油站实现了一键加油、经营分析，会员管理，支付清算，车主服务，经营咨询等功能，为车主提供便捷灵活的加油体验，为油站提供差异化竞争优势。</p>
                        <p><span style="padding-left:28px;"></span>一方面开展会员活动：提高油站会员的转化率；另一方面上线会员等级优惠政策，帮助油站提高会员忠诚度，留存客户又能鼓励消费，大幅度提高油站销量。</p>
                        <p><span style="padding-left:28px;"></span>会员营销系统上线1个月，会员加油订单达到70%，复购率为44%。</p>
                        <p><span style="padding-left:28px;"></span>海马行还帮油站搭建了公众号，会员线上就能注册，自助加油、充值，公众号开通一个月，粉丝超过1000人，油站活动通过微信传播，降低营销成本，效果更胜传统方式。</p>
                    </div>
                    <div class="station_img">
                        <img src="../../assets/productIntro/jyz.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import rotateImg from '../../components/rotateImg.vue'
export default {
    components: {
        rotateImg
    },
    data() {
        return {
            value2: 0,
            autoplayVal: true,
            isActive1: false,
            isActive2: false,
            isActive3: false,
        }
    },
    methods: {
        mouseEnter1(){
            this.isActive1 = true;
        },
        mouseOut1(){
            this.isActive1 = false;
        },
        mouseEnter2(){
            this.isActive2 = true;
        },
        mouseOut2(){
            this.isActive2 = false;
        },
        mouseEnter3(){
            this.isActive3 = true;
        },
        mouseOut3(){
            this.isActive3 = false;
        }
    },
}
</script>

<style scoped>
    .first_img{
        /* width: 100vw; */
    }
    .first_img img{
        width: 100%;
        vertical-align: bottom;
    }
    /* 产品图谱 */
    .product_img{
        height: 952px;
    }
    .product_img_box{
        width: 1200px;
        margin: 0 auto;
    }
    .part_title{
        font-size: 30px;
        padding-top: 48px;
        padding-bottom: 56px;
        color: #333;
    }
    .part_title span{
        padding-left: 70px;
        border-top: 2px solid #0094EB;
        font-size: 0;
    }
    .intro{
        font-size: 14px;
        color: #666;
    }
    .rotation_chant_box{
        
    }
    /* 营销手段 */
    .marketingMeans{
        height: 700px;
        background-color: #FAFAFC;
    }
    .marketingMeans_box{
        width: 1200px;
        margin: 0 auto;
    }
    .marketingMeans_item{
        display: inline-block;
        vertical-align: top;
        background: #fff;
        width: 282px;
        height: 423px;
        margin-right: 24px;
        box-shadow: 0 0 8px 2px #ddd;
    }
    .marketingMeans_item:hover{
        transform: translateY(-10px);
        transition: all linear .3s;
    }
    .marketingMeans_item:last-child{
        margin-right: 0;
    }
    .marketingMeans_item .img_box{
        vertical-align: bottom;
    }
    .marketingMeans_item .title{
        color: #0094EB;
        font-size: 18px;
        padding-top: 32px;
        padding-bottom: 24px;
    }
    .marketingMeans_item .content{
        padding-left: 15px;
        padding-right: 15px;
        font-size: 14px;
        color: #999;
    }
    /* 多种支付方式 */
    .multi_pay{
        height: 800px;
        background-image: url(../../assets/productIntro/pay_bg.jpg);
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .multi_pay_box{
        width: 1200px;
        margin: 0 auto;
    }
    .multi_pay_box .part_title{
        color: white;
    }
    .multi_pay_box .part_title span{
        border-top: 2px solid #ffffff;
    }
    .multi_pay_box .intro{
        color: white;
    }
    .pay_img_box{
        position: relative;
        padding-top: 150px;
    }
    .center_img{
        position: relative;
        margin: auto;
    }
    .pay_img{
        position: absolute;
    }
    .pay_img img:hover{
        transform: rotateZ(360deg);
        transition: all .4s ease-in-out;
    }
    .pay_img p{
        color: white;
        font-size: 18px;
        padding-top: 20px;
    }
    .zhifubao{
        top: 290px;
        left: 210px;
    }
    .saoma{
        top: 90px;
        left: 280px;
    }
    .xianjin{
        top: -30px;
        left: 450px;
    }
    .weixin{
        top: -30px;
        right: 400px;
    }
    .yinhangka{
        top: 100px;
        right: 280px;
    }
    .yve{
        top: 290px;
        right: 210px;
    }
    /* 增值服务 */
    .increment{

    }
    .increment_box{
        width: 1200px;
        margin: 0 auto;
    }
    .increment_list{
        height: 550px;
    }
    .increment_item{
        position: relative;
        display: inline-block;
        vertical-align: top;
        width: 380px;
        height: 390px;
        /* padding: 0 56px; */
        box-shadow: 0 0 8px 2px #eee;
        margin-right: 20px;
    }
    .increment_item:last-child{
        margin-right: 0;
    }
    .over_box{
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        z-index:9999;
    }
    .item_title{
        height: 64px;
        font-size: 24px;
        padding-top: 16px;
        border-bottom: 2px solid #999;
        text-align: left;
        margin: 0 56px 20px;
        padding-left: 40px;
        background-repeat: no-repeat;
        background-position: 0 20px;
    }
    .item_title1{
        background-image: url('../../assets/productIntro/运营分析(1).png');
    }
    .item_title2{
        background-image: url('../../assets/productIntro/fw.png');
    }
    .item_title3{
        background-image: url('../../assets/productIntro/售后.png');
    }
    .item_titles1{
        background-image: url('../../assets/productIntro/yyfx.png');
    }
    .item_titles2{
        background-image: url('../../assets/productIntro/服务.png');
    }
    .item_titles3{
        background-image: url('../../assets/productIntro/sh.png');
    }
    .active1{
        background-color: #0094eb;
        color: white;
    }
    .heighter{
        height: 400px;
        transform: translateY(-13px);
        transition: all linear .3s;
    }
    .item_content{
        padding: 0 56px;
    }
    .item_content li{
        list-style-position:inside;
        text-align: left;
        font-size: 14px;
        color: #666;
    }
    .item_content1 li, .item_content2 li, .item_content3 li{
        height: 40px;
        line-height: 40px;
    }
    .item_content2 li{
        /* height: 70px;
        line-height: 32px; */
    }
    /* 成功案例 */
    .successDemo{
        height: 686px;
        background: #FAFAFC;
    }
    .successDemo_box{
        width: 1200px;
        margin: 0 auto;
    }
    .successDemo_content .content, .successDemo_content .station_img{
        display: inline-block;
        vertical-align: top;
    }
    .successDemo_content .content{
        width: 560px;
        text-align: left;
        font-size: 14px;
        color: #666;
        line-height: 26px;
        padding: 16px 32px 0;
    }
</style>

